import { atom } from 'recoil';

const childDrawerState = atom({
    key: 'childDrawer',
    default: false,
});

export {
    childDrawerState
};